import React from "react";

const EmptyOdds = () => {
  return (
    <dd class="backlay_box">
      <dl class="back-gradient">
        <dd id="back_3" class="mode-land">
          <p></p>
        </dd>
        <dd id="back_2" class="mode-land">
          <p></p>
        </dd>
        <dd id="back_1" class="">
          <a href=""></a>
        </dd>
      </dl>
      <dl class="lay-gradient">
        <dd id="lay_1" class="">
          <a href=""></a>
        </dd>
        <dd id="lay_2" class="mode-land">
          <p></p>
        </dd>
        <dd id="lay_3" class="mode-land">
          <p></p>
        </dd>
      </dl>
    </dd>
  );
};

export default EmptyOdds;
